module.exports = __webpack_public_path__ + "img/banner.31d560b1.png";